import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { CloseAdminModalIcon } from "../../../assets";
import RoundedButton from "../../../shared/components/buttons/RoundedButton";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import { yupResolver } from "@hookform/resolvers/yup";
import { adminActions } from "../../../redux/actions/admin.actions";
import { EMPTY_STRING, PHONE_NUMBER_MASKS } from "../../../constants";
import { addSubAdminSchema } from "../../../schemas";
import {
  encryptObject,
  getDecryptPayload,
  setItemToStorage,
} from "../../../system";
import { authActions } from "../../../redux/actions";

export const AddSubAdmin = (props) => {
  const {
    show,
    onClose,
    addSubAdmin,
    currentData,
    updateSubAdmin,
    updateUser,
  } = props;

  // Initialize form with yupResolver for validation
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setError,
    clearErrors,
    setValue,
  } = useForm({
    resolver: yupResolver(addSubAdminSchema),
    mode: "onChange",
    defaultValues: {
      name: EMPTY_STRING,
      email: EMPTY_STRING,
      phoneNumber: EMPTY_STRING,
    },
  });

  const [phoneLength, setPhoneLength] = useState(0);

  const closeModal = (refetch = false) => {
    reset({
      name: EMPTY_STRING,
      email: EMPTY_STRING,
      phoneNumber: EMPTY_STRING,
    });
    onClose(refetch);
  };
  // Handle form submission
  const onSubmit = (data) => {
    currentData
      ? updateSubAdmin(data, () => {
          closeModal(true);
          const payload = getDecryptPayload();
          if (payload.user.userId === data.id) {
            const ciphertext = encryptObject({
              ...payload,
              user: {
                ...payload.user,
                name: data.name,
                email: data.email,
              },
            });
            setItemToStorage(process.env.REACT_APP_PAYLOAD, ciphertext);
            updateUser({
              ...payload.user,
              name: data.name,
              email: data.email,
            });
          }
        })
      : addSubAdmin(data, () => closeModal(true));
  };

  useEffect(() => {
    console.log(
      "useeffect watch",
      watch("phoneNumber"),
      "phoneLength",
      phoneLength
    );
    if (watch("phoneNumber")) {
      if (
        phoneLength > watch("phoneNumber")?.length &&
        watch("phoneNumber")?.length < 15
      ) {
        setError("phoneNumber", {
          type: "minLength",
          message: "Invalid phone number",
        });
      } else {
        clearErrors("phoneNumber");
      }
    }

    // eslint-disable-next-line
  }, [watch("phoneNumber")]);

  useEffect(() => {
    if (currentData) {
      reset(currentData);
      // setValue("phoneNumber", currentData.phoneNumber);
    }

    // eslint-disable-next-line
  }, [currentData]);

  return (
    <Modal
      centered
      show={show}
      onHide={() => closeModal()}
      className="subadmin-modal"
    >
      <Modal.Header className="align-items-center justify-content-between subadmin-modal-header pt-4 ps-4">
        <div className="subadmin-modal-heading">
          {currentData ? "Update" : "Add"} Sub Admin
        </div>
        <img
          src={CloseAdminModalIcon}
          className="pointer"
          onClick={() => closeModal()}
          alt={EMPTY_STRING}
        />
      </Modal.Header>
      <Modal.Body className="subadmin-modal-body">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="field-container">
            <label className="field-label">Full Name</label>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <input
                  type="text"
                  {...field}
                  className="field"
                  placeholder="Please enter sub-admin's name"
                  autocomplete="off"
                />
              )}
            />
            {errors.name && <p className="error">{errors.name.message}</p>}
          </div>
          <div className="field-container">
            <label className="field-label">Email Address</label>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <input
                  type="text"
                  {...field}
                  className="field"
                  placeholder="Please enter sub-admin's email"
                  autocomplete="off"
                />
              )}
            />
            {errors.email && <p className="error">{errors.email.message}</p>}
          </div>
          <div className="field-container phone-number-field">
            <label className="field-label">Phone Number</label>
            <PhoneInput
              placeholder="(916) 687-9606"
              country={"us"}
              onChange={(phone, country) => {
                setValue("phoneNumber", phone);
                setPhoneLength(
                  country.format.split("").filter((char) => char === ".").length
                );
              }}
              value={watch("phoneNumber")}
              inputExtraProps={{
                required: true,
                autoFocus: true,
              }}
              masks={PHONE_NUMBER_MASKS}
            />
            {/* )}
            /> */}
            {errors.phoneNumber && (
              <p className="error">{errors.phoneNumber.message}</p>
            )}
          </div>
          <div className="d-flex justify-content-center w-100 add-admin-button">
            <RoundedButton
              type="submit"
              className="px-5 py-2"
              disabled={Object.entries(errors).length > 0}
            >
              {currentData ? "Update" : "Add"}
            </RoundedButton>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  addSubAdmin: (data, func) => dispatch(adminActions.addSubAdmin(data, func)),
  updateSubAdmin: (data, func) =>
    dispatch(adminActions.updateSubAdmin(data, func)),
  updateUser: (data) => dispatch(authActions.updateUser(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSubAdmin);
